import React from 'react'
import PropTypes from 'prop-types';

import { Pencil, Plus } from 'lucide-react';
import { Select, Row, Col, FormGroup, Label, Switch, Button, DefaultTooltip, SimpleAlert, ButtonGroup } from 'twyne-new.ui';
import { PureSwitch } from 'components/form/Switch';
import CodeEditor from '@Components/form/CodeEditor';
import ConsentDBAs from '../ConsentDBAs';

class TcpaFormForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tcpaform: {},
      customFields: null,
      customFieldSelected: null
    }
  }

  get allowBidSelection() {
    return this.props.integration?.configuration?.allowBidSelection || false
  }

  componentWillMount() {
    this.updateCustomFields(this.props);
    this.handleEnableManualSubmit({ target: { checked: true } })
  }

  componentWillReceiveProps(props) {
    this.updateCustomFields(props);
  }

  updateCustomFields = ({ integrationData: { extraFields, tcpaform } }) => {

    const customFields = (extraFields || []).map(({
      id, group, type, options, key: value, name: label
    }) => ({
      id, group, type, options, value, label: `${label} (${type})`
    }));
    const customFieldSelected = customFields.find(field => tcpaform.cfid === field.value) || {};
    tcpaform.cfid_number = tcpaform.cfid_number || customFieldSelected.id;

    this.state = {
      tcpaform,
      customFields,
      customFieldSelected
    };

  }

  handleCustomFieldEdit = (cfid) => {
    this.props.onCustomFieldClick({
      cfid,
      customFieldOpen: true
    })
  }

  handleEnable = field => ({ target: { checked } }) => {
    this.props.onChange(field, checked)
  }

  handleChangeCustomField = (cf) => {
    const { tcpaform } = this.state
    const cfid = cf ? cf.value : null
    this.props.onChange('cfid_number', cf ? `${cf.id}` : null);
    this.props.onChange('cfid', cfid)
    const { leadid, trustedform } = tcpaform
    leadid && this.props.onChange('leadid_cfid', `${cfid}_leadid`)
    trustedform && this.props.onChange('trustedform_cfid', `${cfid}_trustedform`)
  }

  handleEnableManualSubmit = evt => {
    this.handleEnable('manualSubmit').call(this, evt)
    evt.target.checked && this.props.onCustomFieldClick({ hideHostedSubmit: false })
  }

  handleEnableLeadId = (e) => {
    let checked = e.target.checked

    if (checked) {
      if (this.state.tcpaform.cfid === null || this.state.tcpaform.cfid === undefined) return
      this.props.onChange('leadid', checked)
      this.props.onChange('leadid_cfid', `${this.state.tcpaform.cfid}_leadid`)
    } else {
      this.props.onChange('leadid', false)
      this.props.onChange('leadid_cfid', '')
    }

  }

  handleEnableTrustedForm = (e) => {
    let checked = e.target.checked

    if (checked) {
      if (this.state.tcpaform.cfid === null || this.state.tcpaform.cfid === undefined) return
      this.props.onChange('trustedform', checked)
      this.props.onChange('trustedform_cfid', `${this.state.tcpaform.cfid}_trustedform`)
    } else {
      this.props.onChange('trustedform', false)
      this.props.onChange('trustedform_cfid', '')
    }

  }

  render() {
    return (
      <div key={this.state.tcpaform.cfid || ''}>
        <Row>
          <Col size="6">
            <FormGroup>
              <Label>Custom Field</Label>
              <Select name="type" value={this.state.tcpaform.cfid || ''} options={this.state.customFields}
                onChange={this.handleChangeCustomField} disabled={this.props.disabled} />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>&nbsp;</Label>
              <ButtonGroup>
                <Button color="accent" disabled={this.props.disabled} onClick={() => this.handleCustomFieldEdit()}>
                  <Plus size={14} />
                  Add
                </Button>
                <DefaultTooltip content='Edit' triggerProps={{ asChild: true }}>
                  <Button variant='outline' color="accent" disabled={this.props.disabled || !this.state.tcpaform.cfid_number} onClick={() => this.handleCustomFieldEdit(this.state.tcpaform.cfid_number)}>
                    <Pencil size={14} />
                  </Button>
                </DefaultTooltip>
              </ButtonGroup>
            </FormGroup>
          </Col>
        </Row>
        <Row className='mt-4'>
          <Col size='2'>
            <FormGroup>
              <Label>Trusted Form?</Label>
              <Switch
                onChange={(e) => this.handleEnableTrustedForm(e)}
                checked={this.state.tcpaform.trustedform || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>LeadId?</Label>
              <Switch
                onChange={(e) => this.handleEnableLeadId(e)}
                checked={this.state.tcpaform.leadid || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>Always Visible?</Label>
              <Switch
                onChange={this.handleEnable('alwaysShow')}
                checked={this.state.tcpaform.alwaysShow || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>Consent text</Label>
              <Switch
                onChange={this.handleEnable('consentTextActive')}
                checked={this.state.tcpaform.consentTextActive || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>Auto Scroll to Consent</Label>
              <Switch
                onChange={this.handleEnable('autoScrollToConsent')}
                checked={this.state.tcpaform.autoScrollToConsent || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>Manual Submit</Label>
              <PureSwitch
                onChange={this.handleEnableManualSubmit}
                value={this.state.tcpaform.manualSubmit || false}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>Save Consent Text</Label>
              <Switch
                onChange={this.handleEnable('saveConsentText')}
                checked={this.state.tcpaform.saveConsentText || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size="12">
            <FormGroup>
              <Label>Title</Label>
              <CodeEditor
                name="question"
                value={this.state.tcpaform.question || ''}
                onChange={value => this.props.onChange('question', value)}
                disabled={this.props.disabled}
                resizable
                height="100px"
              />
            </FormGroup>
          </Col>
          {this.state.tcpaform.consentTextActive ? <>
            { this.allowBidSelection ? <>
              <Col size="12">
                <SimpleAlert color="warning">
                  This integration requires using the helpers to render DBA's checkbox in your consent text.
                </SimpleAlert>
              </Col>
            </> : null}
            <Col size='12'>
              <FormGroup>
                <Label className='flex justify-between items-center'>
                  Consent text
                  { this.allowBidSelection ? <ConsentDBAs
                    data={this.state.tcpaform.dbas}
                    onChange={data => this.props.onChange('dbas', data)}
                  /> : null }
                </Label>
                <CodeEditor
                  name="consentText"
                  value={this.state.tcpaform.consentText || ''}
                  onChange={value => this.props.onChange('consentText', value)}
                  disabled={this.props.disabled}
                  resizable
                  height="100px"
                />
              </FormGroup>
            </Col>
          </> : null}
        </Row>
      </div>
    );
  }
}
TcpaFormForm.propTypes = {
  data: PropTypes.any,
  integrationData: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  onCustomFieldClick: PropTypes.func
}

export default TcpaFormForm;
